import React, { useEffect, useMemo } from "react"
import { graphql } from "gatsby"
import useEdlynProductQuery from "../../../hooks/use-edlyn-product-query"
import useBoneProductQuery from "../../../hooks/use-bone-product-query"
import useGreenwheatProductQuery from "../../../hooks/use-greenwheat-product-query"
import useWoodsProductQuery from "../../../hooks/use-woods-product-query"
import ProductCard from "../../cards/product"
import { Link } from "../../../../plugins/gatsby-plugin-atollon"
import ProductsFilter from "./products-filter"
import sal from 'sal.js'

const ProductArchive = ({brand, theme}) => {
  const [category, setCategory] = React.useState('')
  const [searchText, setSearchText] = React.useState('')

  const edlyn = useEdlynProductQuery()
  const bone = useBoneProductQuery()
  const greenwheat = useGreenwheatProductQuery()
  const woods = useWoodsProductQuery()

  useEffect(() => {
    sal()
  }, [category])

  const {
    baseProducts,
    categories,
  } = useMemo(() => {
    let products;
    switch (theme) {
      case "edlyn":
        products = edlyn
        break
      case "bone":
        products = bone
        break
      case "greenwheat":
        products = greenwheat
        break
      case "woods":
        products = woods
        break
      default:
        products = edlyn
    }
    const uniqueCategories = [...new Set([...products.map(a => a.category.map(b => b.title)).map(c => c).map(c => c.join(','))].join(',').split(',').filter(Boolean))]
    return {
      baseProducts: products,
      categories: uniqueCategories,
    }
  }, [theme])

  const filteredProducts = useMemo(() => {
    const filteredToCategory = (() => {
      if (category) {
        return baseProducts.filter(el => el.category.some(cat => {
          return cat.title.split(' ').join('-').toLowerCase() === category
        }))
      }
      return baseProducts
    })();


    const searchTerms = searchText.toLowerCase().split(' ');

    return (() => {
      if (searchTerms && searchTerms.length > 0) {
        return filteredToCategory.filter(product => {
          return searchTerms.every(term =>
            product.title.toLowerCase().includes(term)
          );
        });
      }
      return filteredToCategory
    })()
  }, [searchText, category])

  return (
    <section className={`product-archive ${theme}`}>
      <div className="product-archive__inner">
        {
          theme !== 'greenwheat' &&
          <ProductsFilter onInput={(txt) => setSearchText(txt)}
                          onClick={(cat) => {
                            setCategory(cat.split(' ').join('-').toLowerCase())
                            window.history.pushState('', '', `${window.location.pathname}?category=${cat.split(' ').join('-').toLowerCase()}`)
                          }}
                          category={categories} theme={theme}/>
        }
        <div className="product-archive__items">
          {
            filteredProducts?.length > 0 && filteredProducts.map((el, i) => (
              <Link to={el.permalink} key={i} className="product-archive__item" data-sal="slide-up" data-sal-duration="1000"
                    data-sal-easing="ease">
                <ProductCard {...el} />
              </Link>
            ))
          }
        </div>
      </div>
    </section>
  )
}

export default ProductArchive

export const query = graphql`
fragment ProductArchiveProps on DatoCmsProductArchive {
  ... on DatoCmsProductArchive {
    id
    brand
  }
}
`
